import type { ConfigurationJobOperator, ConfigurationQueueItem } from "./configurationApi";

export function filterConfigurationOperatorsForJob(
  operators: ConfigurationJobOperator[],
  mode: "build" | "alternate_order" | "alternate",
  batchItemId: number,
  alternateOrderId: number,
  alternateSku: string,
): ConfigurationJobOperator[] {
  if (mode === "build") {
    return operators.filter((operator) => operator.batchItemId === batchItemId);
  }
  if (mode === "alternate_order") {
    return operators.filter((operator) => operator.alternateOrderId === alternateOrderId);
  }
  const normalizedSku = alternateSku.trim();
  if (normalizedSku === "") return [];
  return operators.filter(
    (operator) => operator.alternateSku != null && operator.alternateSku.trim() === normalizedSku,
  );
}

export function filterConfigurationOperatorsForQueueItem(
  operators: ConfigurationJobOperator[],
  item: ConfigurationQueueItem,
): ConfigurationJobOperator[] {
  if (item.kind === "batch_line" && item.batchItemId != null) {
    return operators.filter((operator) => operator.batchItemId === item.batchItemId);
  }
  if (item.kind === "alternate_order" && item.alternateOrderId != null) {
    return operators.filter((operator) => operator.alternateOrderId === item.alternateOrderId);
  }
  return [];
}

/**
 * Background job-progress / built-units polling: off for a solo operator while units remain;
 * on when two or more operators share the job, or when remaining hits zero (QC can reopen).
 */
export function configurationJobSyncRefetchIntervalMs(
  operatorsOnJob: ConfigurationJobOperator[],
  remainingToBuild: number | null | undefined,
  multiOperatorIntervalMs: number,
  atZeroIntervalMs: number,
): number | false {
  if (remainingToBuild != null && remainingToBuild <= 0) {
    return atZeroIntervalMs;
  }
  if (operatorsOnJob.length >= 2) {
    return multiOperatorIntervalMs;
  }
  return false;
}
